import { routes } from '@/config/routes';
import { AccountType, UserRole } from '@/types';

/**
 * Where a session belongs, given its role and account type.
 *
 * Single source of truth for post-login and post-account-switch navigation. It
 * exists because the account switchers used to hard-redirect every session to
 * `routes.root` (/leads): that route is not mounted for an END_CUSTOMER session
 * (App.tsx renders the EC layout, which mounts only the EC routes and has no
 * catch-all), so switching a channel partner into their own end-customer account
 * rendered an empty page with no way back.
 *
 * Also consumed by ProtectedRoute, which previously kept a private copy of this map.
 */
export const landingRouteForUser = (user: {
  role?: UserRole | string | null;
  accountType?: AccountType | string | null;
}): string => {
  if (user?.role === UserRole.END_CUSTOMER) {
    return routes.ec.projects;
  }

  // API_ADMIN only means anything inside an API partner account; anywhere else the
  // api-keys page is not authorized, so fall through to the generic root.
  if (user?.role === UserRole.API_ADMIN && user?.accountType === AccountType.API_PARTNER) {
    return routes.api.apiKeys.root;
  }

  if (user?.role === UserRole.BRAND_AMBASSADOR) {
    return routes.opportunities.root;
  }

  return routes.root;
};
